import React from "react";
import "./GPTeam.css";

const teamMembers = [
  { name: "सौ.कविता कैलास रंगारी ", designation: "ग्रामपंचायत ठोंबरा ", phone: "+91 8329769426", imageUrl: "/images/kavita.jpeg" },
  { name: "श्री. यागेश सखाराम इंगळे", designation: "ग्रामपंचायत ठोंबरा", phone: "+91 9823425631", imageUrl: "/images/yoges.jpeg" },
  { name: "श्री. संदीप माधो शामकुवर", designation: "ग्रामपंचायत ठोंबरा", phone: "+91 8329851681", imageUrl: "/images/sandip.jpeg" },
  { name: "सौ. माधुरी चंद्रभान गायकवाड", designation: "ग्रामपंचायत ठोंबरा", phone: "+91 9689473593", imageUrl: "/images/kamini.jpeg" },
  { name: "सौ. वंदना गजानन मेश्राम", designation: " ग्रामपंचायत ठोंबरा ", phone: "+91 79723 03268", imageUrl: "/images/samiksha.jpeg" },
  { name: "सौ. मंगला हरिदास खेळकर", designation: "ग्रामपंचायत ठोंबरा", phone: "+91 9921681063", imageUrl: "/images/asmita.jpeg" },

  
];

const karmachariMembers = [
  { name: " श्री. शेषराव रामदास गेडाम ", designation: "ग्राम पंचायत कर्मचारी", imageUrl: "/images/shesrao.jpeg" },
  { name: "श्री. बाबा शंकर राऊत  ", designation: "संगणक परिचालक", imageUrl: "/images/raut6.jpeg" },
  
];


const GPTeam = () => {
  return (
    <div className="gp-container">

      {/* HEADER */}
      <div className="gp-header">
        <img
          src="/images/sj1.jpg"
          alt="Emblem"
          className="gp-logo"
        />
        <h1 className="gp-title">ग्रामपंचायत कार्यकारी समिती</h1>
        <p className="gp-subtitle">
          The Governing Body — Committed to Community Service
        </p>
      </div>

      {/* TEAM CARDS */}
      <div className="gp-grid">
        {teamMembers.map((member, index) => (
          <div key={index} className="gp-card">
            <img
              src={member.imageUrl}
              alt={member.name}
              className="gp-photo"
            />
            <h2 className="gp-name">{member.name}</h2>
            <p className="gp-designation">{member.designation}</p>
            <p className="gp-phone">📞 {member.phone}</p>
          </div>
        ))}
      </div>
      {/* KARMACHARI SECTION */}
      <h2 className="gp-section-title">कर्मचारी</h2>

      <div className="gp-grid">
        {karmachariMembers.map((member, index) => (
          <div key={index} className="gp-card">
            <img
              src={member.imageUrl}
              alt={member.name}
              className="gp-photo"
            />
            <h2 className="gp-name">{member.name}</h2>
            <p className="gp-designation">{member.designation}</p>
          </div>
        ))}
      </div>

      {/* FOOTER */}
      <div className="gp-footer">
        © 2025 Gram Panchayat — All Rights Reserved.
      </div>
    </div>
  );
};

export default GPTeam;
